import instanceBaseUrl from "./axios";

/**
 * Admin moderation API (riddle backend, mounted at /api/v1/moderation).
 * Every call returns the raw axios response; callers read `resp.data.data`
 * for the payload and `resp.data.message` for a success message, matching
 * the APIResponse envelope used everywhere else in this app.
 */

// ── reports ────────────────────────────────────────────────────────────────
export const getReports = async ({
  status,
  contentType,
  isOverdue,
  page = 1,
  limit = 20,
} = {}) => {
  return instanceBaseUrl.get("/moderation/reports", {
    params: {
      ...(status && { status }),
      ...(contentType && { content_type: contentType }),
      ...(isOverdue !== undefined &&
        isOverdue !== null && { is_overdue: isOverdue }),
      page,
      limit,
    },
  });
};

export const getReportStats = async () => {
  return instanceBaseUrl.get("/moderation/reports/stats");
};

export const getReportDetail = async (reportId) => {
  return instanceBaseUrl.get(`/moderation/reports/${reportId}`);
};

export const actionReport = async (reportId, type, note) => {
  return instanceBaseUrl.post(`/moderation/reports/${reportId}/action`, {
    type,
    note: note || "",
  });
};

// ── violations / suspensions ───────────────────────────────────────────────
export const getViolations = async ({ status } = {}) => {
  return instanceBaseUrl.get("/moderation/violations", {
    params: { ...(status && { status }) },
  });
};

export const getUserViolations = async (userId) => {
  return instanceBaseUrl.get(`/moderation/users/${userId}/violations`);
};

export const revokeSuspension = async (violationId, reason) => {
  return instanceBaseUrl.post(`/moderation/violations/${violationId}/revoke`, {
    reason,
  });
};

// ── appeals ────────────────────────────────────────────────────────────────
export const reviewAppeal = async (violationId, approved, note) => {
  return instanceBaseUrl.post(
    `/moderation/violations/${violationId}/appeal/action`,
    { approved, note: note || "" }
  );
};

// ── content ────────────────────────────────────────────────────────────────
export const hideContent = async (contentId, contentType, reason) => {
  return instanceBaseUrl.post(`/moderation/content/${contentId}/hide`, {
    content_type: contentType,
    reason: reason || "",
  });
};

export const unhideContent = async (contentId) => {
  return instanceBaseUrl.post(`/moderation/content/${contentId}/unhide`);
};

// ── shared label maps ──────────────────────────────────────────────────────
export const REPORT_REASON_LABELS = {
  harassment: "Harassment or bullying",
  hate_speech: "Hate speech",
  spam: "Spam or scam",
  inappropriate: "Inappropriate content",
  fake_profile: "Fake profile",
  scam: "Fraud or scam",
  violence: "Violence or threats",
  false_review: "False or fake review",
  other: "Other",
};

export const CONTENT_TYPE_LABELS = {
  message: "Chat message",
  profile: "Profile",
  review: "Review",
  job_post: "Job post",
};

export const REPORT_ACTIONS = [
  { value: "warn", label: "Issue Warning" },
  { value: "suspend_3", label: "Suspend 3 Days" },
  { value: "suspend_7", label: "Suspend 7 Days" },
  { value: "suspend_permanent", label: "Permanent Ban" },
  { value: "hide_content", label: "Hide Content Only" },
  { value: "dismiss", label: "Dismiss Report" },
];
